import { render, staticRenderFns } from "./VueAudio.vue?vue&type=template&id=545f86c3&scoped=true"
import script from "./VueAudio.vue?vue&type=script&lang=js"
export * from "./VueAudio.vue?vue&type=script&lang=js"
import style0 from "./VueAudio.vue?vue&type=style&index=0&id=545f86c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545f86c3",
  null
  
)

export default component.exports